import React, {useState, useEffect} from 'react';
import Button from '../Components/Button';
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {message, Modal, Spin} from 'antd';
import RadioCustom from '../Components/RadioCustom';
import {useToken} from '../context/TokenContext'
import {HAPPY_PAY_PUBLIC, LOGIN_CLOSED} from '../config/campaign'

const baseURL = process.env.REACT_APP_API_BASE_URL;
// const baseURL = "https://172.29.2.23:81";

/**
 * ТЕСТИЙН ШУУД НЭВТРЭЛТ — PROD дээр ЗААВАЛ null байна.
 *
 * null биш үед "ДАН нэвтрэх" товч ДАН руу үсрэхийн оронд localData-г шууд
 * бөглөөд самбар руу оруулна. Ингэснээр тестийн орчинд ДАН-гүйгээр нэвтэрнэ.
 *
 * ЖИЧ: Энэ нь зөвхөн фронтендын тал. Backend талд happy-pay-cust.php доторх
 * TEST_REGNO-г мөн асаах шаардлагатай, эс бөгөөс API 401 буцаана. Хоёуланг нь
 * PROD дээр унтраана.
 */
const TEST_LOGIN = null;                                              // PROD
// const TEST_LOGIN = {regnum: 'УП96090721', reff_id: 'TEST', type: 'happypay'}; // TEST
let phase = 1
const nowDate = new Date();
const draw = new Date('2024-07-10T18:00:00');

if (nowDate > draw) {
    phase = 2
}

const options = [
    {
        label: 'Хуримтлалтай Монгол',
        value: 0,
        url: "https://www.cardcentre.mn/eregister/index.php?appid=loyalty_sm",
        img: phase === 1 ? "/images/hm_login.png" : "/images/HM-2026-1-Mobile.png"

    },
    // {
    //   label: 'Happy Merchant',
    //   value: 1,
    //   url: '',
    //   img: '/images/happy_merchant_2025-2.jpg'
    // },
    // {
    //     label: 'Apple Pay',
    //     value: 1,
    //     url: "https://www.cardcentre.mn/eregister/index.php?appid=apple",
    //     img: "/apple_pay/june-update/apple-login.jpg"
    // },
    {
        // `value` must equal this entry's array index: the render reads
        // options[link].url / .img, where `link` holds the selected value.
        label: 'Happy Pay',
        value: 1,
        url: "https://www.cardcentre.mn/eregister/index.php?appid=happypay",
        img: "/happy_pay_2026/1350x1350.jpg",
        // Soft launch: withheld from the chooser, but left in the array so the
        // indexes below still line up and `/login?link=1` keeps working for a
        // direct check. @see HAPPY_PAY_PUBLIC
        hidden: !HAPPY_PAY_PUBLIC
    }
];

/** What the chooser offers. `options` itself must stay whole — see `hidden`. */
const visibleOptions = options.filter(option => !option.hidden);

const Login = () => {
    const navigate = useNavigate();
    // let { id, reg } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('reff');
    const reg = searchParams.get('reg');
    const cmd = searchParams.get('cmd');
    const linkVal = searchParams.get('link');
    const [link, setLink] = useState(0);
    const [merchantRegno, setMerchantRegno] = useState('');
    const [OTP, setOTP] = useState(new Array(6).fill(''));
    const [otpId, setOTPId] = useState('');
    const [merchantLoginError, setMerchantLoginError] = useState(null);
    const [merchantOTPError, setMerchantOTPError] = useState("");
    const [showOTPInput, setShowOTPInput] = useState(false);
    const [token, setToken] = useToken();
    const [loading, setLoading] = useState(false);
    const [merchantEmail, setMerchantEmail] = useState("");


    useEffect(() => {
        if (linkVal != null) setLink(parseInt(linkVal));
        if (reg === null && id === null && cmd === null) {
            const items = JSON.parse(localStorage.getItem('localData'));
            if (items) {
                if (items.type === 'visa') {
                    navigate("/dashboardvisa");
                } else if (items.type === 'saving') {
                    navigate("/dashboardsaving");
                } else if (items.type === 'apple') {
                    navigate("/dashboardapple");
                } else if (items.type === 'happypay') {
                    // 'happypay', not 'happy': fetchLogin stores `type: cmd` and
                    // the cmd is 'happypay'. The old value never matched, so a
                    // returning customer fell to the else and had their session
                    // cleared.
                    navigate("/dashboardhappy");
                } else {
                    localStorage.removeItem("localData");
                }
            }
        } else if (LOGIN_CLOSED) {
            // A DAN round-trip started before the switch flipped still lands
            // here; ignore it silently. @see LOGIN_CLOSED
        } else {
            fetchLogin();
        }

    }, []);

    useEffect(() => {
        if (token !== null && token !== false && token.length !== 0) {
            navigate('/dashboardmerchant');
        }
    }, [token]);

    useEffect(() => {
        if (merchantLoginError != null && merchantLoginError.length !== 0) {
            message.error(merchantLoginError).then();
            setMerchantLoginError(null)
        }
    }, [merchantLoginError])


    async function fetchLogin() {

        const data = {
            regnum: reg,
            reff_id: id,
        };

        try {
            const response = await axios.post(`${baseURL}/happypay/index.php?cmd=login`, data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            let res = response.data
            if (res.status === true) {
                localStorage.setItem(
                    "localData",
                    JSON.stringify({
                        regnum: res.data.regnum,
                        reff_id: res.data.reff_id,
                        type: cmd,
                    })
                );
                message.success("Амжилттай нэвтэрлээ.");
                if (cmd === 'visa') {
                    navigate("/dashboardvisa");
                } else if (cmd === 'saving') {
                    navigate("/dashboardsaving");
                } else if (cmd === 'apple') {
                    navigate("/dashboardapple");
                } else if (cmd === 'happypay') {
                    navigate("/dashboardhappy");
                } else {
                    localStorage.removeItem("localData");
                    message.error("Алдаа гарлаа.");
                }
            } else {
                localStorage.removeItem("localData");
                message.error("Алдаа гарлаа.");
            }
        } catch (error) {
            message.error("Алдаа гарлаа.");
        }
    }

    /** Тестийн горимд ДАН-гүйгээр шууд нэвтэрнэ. @see TEST_LOGIN */
    const testLogin = () => {
        localStorage.setItem("localData", JSON.stringify(TEST_LOGIN));
        navigate("/dashboardhappy");
    };

    const changeType = (value) => {
        setLink(value);
    };

    const handleChange = (event) => {
        setMerchantRegno(event.target.value);
    }
    const handleOTP = (event, index) => {
        const value = event.target.value;
        if (/^[0-9]$/.test(value) || value === '') {
            const newOTP = [...OTP];
            newOTP[index] = value;
            setOTP(newOTP);

            if (value !== '' && index < 5) {
                document.getElementById(`otp${index + 1}`).focus();
            }
        }
    }

    const handleMerchantLogin = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${baseURL}/happypay/login.php/happy-merchant`, {
                regno: merchantRegno
            });
            if (response.status === 200) {
                setOTPId(response.data.id);
                setMerchantEmail(response.data.firstLetterEmail + "*****" + response.data.lastLetterEmail + "@****." + response.data.tld);
                setShowOTPInput(true);
            } else {
                console.log(response.data);
                setMerchantLoginError(response.data);
            }
        } catch (error) {
            console.log(error);
            if (error.response) {
                let errorData = error.response.data;
                switch (errorData['errorcode']) {
                    case 404:
                        setMerchantLoginError("Таны оруулсан регистрийн дугаартай харилцагч олдсонгүй");
                        break;
                    case 500:
                        setMerchantLoginError("Алдаа гарлаа та түр хүлээн дахин оролдоно уу!");
                        break;
                }
            } else {
                message.error("Сервер хүсэлт хүлээн авах боломжгүй байгаа тул та түр хүлээн дахин оролдоно уу.");
            }
        } finally {
            setLoading(false);
        }
    }

    const handleMerchantOTPInput = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${baseURL}/happypay/login.php/happy-merchant/otp`, {
                id: otpId,
                otp: (OTP.join("")).trim()
            });
            if (response.status === 200) {
                setToken(response.data.token);
            } else {
                setOTP(new Array(6).fill(''))
                setMerchantOTPError(response.data.errormessage);
            }
        } catch (error) {
            if (error.response) {
                let errorData = error.response.data;
                console.log(errorData);
                switch (errorData['errorcode']) {
                    case 401:
                        setOTP(new Array(6).fill(''))
                        document.getElementById(`otp0`).focus();
                        setMerchantOTPError("Таны оруулсан баталгаажуулах код буруу байна");
                        break;
                    case 419:
                        setOTP(new Array(6).fill(''))
                        setMerchantOTPError("Таны баталгаажуулах код оруулах хугацаа дууссан байна дахин нэвтэрнэ үү.");
                        setShowOTPInput(false);
                        break;
                    case 500:
                        setOTP(new Array(6).fill(''))
                        setMerchantOTPError("Алдаа гарлаа та түр хүлээн дахин оролдоно уу!");
                        setShowOTPInput(false);
                        break;
                }
            } else {
                message.error("Сервер хүсэлт хүлээж авах боломжгүй байна. Та түр хүлээн дахин оролдоно уу.");
            }
        } finally {
            setLoading(false);
        }
    }

    function cancelOTP() {
        setOTPId(null);
        setShowOTPInput(false);
        setMerchantRegno("");
    }

    function handleOTPKeyDown(event, index) {
        if (event.key === 'Backspace' && OTP[index] === '' && index > 0) {
            document.getElementById(`otp${index - 1}`).focus();
            event.target.style.caretColor = 'transparent';
            setTimeout(() => {
                event.target.style.caretColor = '';
            })
        } else if (event.key === 'Enter') {
            handleMerchantOTPInput().then();
        }
    }

    async function handleResendOTP() {
        try {
            const response = await axios.put(`${baseURL}/happypay/login.php/happy-merchant/otp`, {
                id: otpId
            });
            if (response.status === 200) {
                let email = response.data.firstLetterEmail + "*****" + response.data.lastLetterEmail + "@****." + response.data.tld;
                message.info(`Таны ${email} хаягт баталгаажуулах код дахин явууллаа`);
            }
        } catch (error) {
            if (error.response) {
                const data = error.response;
                switch (data.status) {
                    case 401:
                    case 404:
                        setMerchantOTPError("Та дахин оролдоно уу");
                }
            }
        }
    }

    return (
        <div
            className='w-full h-screen mobile-Merchant:h-fit mobile-Merchant:w-full flex justify-center items-center tablet-Merchant:justify-start bg-blue-100'>
            <div
                className='w-9/12 h-3/4 max-w-[1600px] laptop-Merchant:w-11/12 bg-white rounded-xl z-40 px-8 py-6 mobile:py-0 mobile:px-0 flex flex-col space-y-6 tablet-Merchant:h-screen tablet-Merchant:w-full tablet-Merchant:items-start mobile-Merchant:w-full mobile-Merchant:h-full mobile-Merchant:items-center'>
                <div
                    className='w-full tablet-Merchant:pt-6 tablet-Merchant:pl-6 flex justify-between items-center pb-6 border-b-2 border-ECF0F3 mobile-Merchant:hidden'>
                    <a href='/'><img className="w-28 h-auto mobile-Merchant:w-full mobile-Merchant:h-[50px]"
                                     src="/images/TDB_loyalty.png"/></a>
                </div>

                {/* bodysection */}
                <div
                    className='flex justify-center items-center w-full h-full tablet-Merchant:flex-col-reverse mobile-Merchant:flex-col-reverse tablet-Merchant:justify-end tablet-Merchant:gap-10'>

                    {/* left */}
                    <div
                        className='flex flex-col w-7/12 h-full justify-center items-center space-y-4 tablet-Merchant:w-full tablet-Merchant:h-fit '>
                        <RadioCustom checked={link} options={visibleOptions} changeType={changeType}/>
                        {/*  Happy Merchant нэвтрэх хэсэг*/}
                        {/*{link === 1 ? (*/}
                        {/*    <div className="flex flex-col justify-center">*/}
                        {/*      <div className="flex justify-between items-center mt-5 mb-5 mobile-Merchant:ml-2 mobile-Merchant:justify-start tablet-Merchant:justify-start">*/}
                        {/*        <label htmlFor='merchant-regno' className="w-1/2">Регистрийн дугаар: </label>*/}
                        {/*        <input type='text' id='merchant-regno' value={merchantRegno} onChange={handleChange}*/}
                        {/*               className="rounded-xl appearance-none border-2 border-[#0987F3] w-1/2 py-2 px-3 text-gray-700 tablet-Merchant:w-[300px] mobile-Merchant:w-[150px] " />*/}
                        {/*      </div>*/}
                        {/*      {showOTPInput && (*/}
                        {/*          <Modal open={showOTPInput}*/}
                        {/*                 okButtonProps={{style: {backgroundColor: '#0987F3'}}}*/}
                        {/*                 className="block m-auto max-h-[400px] rounded shadow-lg"*/}
                        {/*                 title="Баталгаажуулах"*/}
                        {/*                 onOk={() => handleMerchantOTPInput(OTP)}*/}
                        {/*                 onCancel={cancelOTP}*/}
                        {/*                 okText="Нэвтрэх"*/}
                        {/*                 cancelText="Өөр харилцагчаар нэвтрэх">*/}
                        {/*            <hr className="h-px border-0 bg-[#0987F3]"/>*/}
                        {/*            <div className="flex flex-col w-full!important my-5">*/}
                        {/*              <p className="text-justify"> Таны {merchantEmail} хаягт OTP код*/}
                        {/*                илгээгдлээ.  </p>*/}
                        {/*              <p>Баталгаажуулах кодыг оруулна уу.</p>*/}
                        {/*              <div className="flex gap-2 my-5">*/}
                        {/*                {OTP.map((digit, i) => (*/}
                        {/*                    <input*/}
                        {/*                        key={i}*/}
                        {/*                        type="tel"*/}
                        {/*                        pattern="[0-9]*"*/}
                        {/*                        inputMode="numeric"*/}
                        {/*                        id={`otp${i}`}*/}
                        {/*                        maxLength="1"*/}
                        {/*                        value={digit}*/}
                        {/*                        onChange={(event) => handleOTP(event, i)}*/}
                        {/*                        onKeyDown={(event) => handleOTPKeyDown(event, i)}*/}
                        {/*                        className="border border-black w-1/6 h-[5vh] rounded-md text-3xl text-center"/>))}*/}
                        {/*              </div>*/}
                        {/*              <div hidden={!(loading && showOTPInput)}><Spin className="block mx-auto my-2"/></div>*/}
                        {/*              <p className="text-red-500 mb-5" hidden={(merchantOTPError == null || merchantOTPError.length === 0 )}>{merchantOTPError}</p>*/}
                        {/*              <div className="flex gap-2 w-full mb-5 justify-end mt-1">*/}
                        {/*                <Button onclick={handleResendOTP} name="Баталгаажуулах код дахин авах"/></div>*/}
                        {/*            </div>*/}
                        {/*          </Modal>*/}
                        {/*      )}*/}
                        {/*      {(loading && !showOTPInput) && (*/}
                        {/*          <>*/}
                        {/*            <br/>*/}
                        {/*            <Spin className="block m-auto"/>*/}
                        {/*            <br/>*/}
                        {/*          </>*/}
                        {/*      )}*/}
                        {/*      <Button*/}
                        {/*          onclick={handleMerchantLogin}*/}
                        {/*          style='bg-[#0987F3] text-white text-2xl font-semibold rounded-xl w-[600px] h-[58px] shadow-lg block mx-auto laptop-Merchant:w-[540px] tablet-Merchant:w-[600px] mobile-Merchant:w-[360px] hover:bg-[#0168D7] duration-300'*/}
                        {/*          name='Нэвтрэх'*/}
                        {/*      />*/}
                        {/*      <p className='w-[600px] text-[#0987F3] text-center text-sm rounded-xl laptop-Merchant:w-[540px]  tablet-Merchant:w-[600px] mt-2 mobile-Merchant:w-[360px]'>Та*/}
                        {/*        Худалдаа*/}
                        {/*        хөгжлийн банкны Happy Merchant хөтөлбөрийн мэдээлэл авахын тулд регистрийн дугаараар нэвтэрнэ*/}
                        {/*        үү.</p>*/}
                        {/*    </div>*/}
                        {/*) : (*/}
                        <div>
                            {LOGIN_CLOSED ? null : TEST_LOGIN ? (
                                // Тестийн горим: ДАН руу үсрэхгүй, шууд самбар руу.
                                <Button
                                    style='bg-amber-500 text-white text-2xl font-semibold rounded-xl w-[600px] h-[58px] shadow-lg laptop-Merchant:w-[540px] tablet-Merchant:w-[600px] block mx-auto mobile-Merchant:w-[360px] hover:bg-amber-600 duration-300'
                                    onclick={testLogin} name='ТЕСТ — шууд нэвтрэх'/>
                            ) : (
                                <Button
                                    style='bg-[#0987F3] text-white text-2xl font-semibold rounded-xl w-[600px] h-[58px] shadow-lg laptop-Merchant:w-[540px]  tablet-Merchant:w-[600px] block mx-auto mobile-Merchant:w-[360px] hover:bg-[#0168D7] duration-300'
                                    link={options[link].url} name='ДАН нэвтрэх'/>
                            )}
                            {!LOGIN_CLOSED && (
                                <p className='w-[600px] text-[#0987F3] rounded-xl text-sm mt-3 laptop-Merchant:w-[540px] tablet-Merchant:w-[600px] mobile-Merchant:w-[360px]'>Та
                                    Худалдаа
                                    хөгжлийн банкны Урамшуулалт хөтөлбөрийн мэдээлэл авахын тулд ДАН баталгаажуулалтаар
                                    нэвтэрнэ үү.</p>
                            )}
                        </div>

                        {/*)}*/}

                    </div>

                    {/* right */}
                    <div
                        className='w-7/12 h-fit flex justify-center items-center tablet-Merchant:w-full mobile-Merchant:w-full mobile:items-start tablet-Merchant:mobile:items-start'>
                        <img
                            className='w-[450px] h-[450px] bg-slate-300 tablet-Merchant:w-[600px] tablet-Merchant:h-[400px] mobile-Merchant:w-[360px] rounded-xl mobile-Merchant:h-[360px] object-cover'
                            src={options[link].img} alt="square_banner"/>
                    </div>
                    <div
                        className='justify-start items-center w-[300px] h-24 hidden mobile-Merchant:flex mb-4 mobile-Merchant:h-[30px]'>
                        <a href='/'><img className="w-28 h-auto mobile:w-[120px] mobile:h-auto "
                                         src="/images/TDB_loyalty.png"/></a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;